export default function Footer() {
  return (
    <footer className="footer">Desarrollado por <a href="https://ec-innova.es/" className="colorWhite" rel="noreferrer noopener" target="_blank">EC-INNOVA</a> 2023</footer>
  )
}
